import { request } from '@/utils/api-request'

export function getStorageList (params) {
  const url = '/admin/storage/list'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export function getStorageInsertMeta (force) {
  const url = '/admin/storage/insert'
  const config = {
    method: 'get',
    url
  }
  return request(config, force, '24h')
}

export function getStorageInsert (params) {
  const url = '/admin/storage/insert'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export function getStorageInfo (params) {
  const url = '/admin/storage/info'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}

export function removeStorage (params) {
  const url = '/admin/storage/delete'
  const config = {
    method: 'post',
    url,
    data: params
  }
  return request(config, true)
}
